module.exports = __webpack_public_path__ + "media/images/lock-cd8858414692c337cecfb6341aa90a50.jpg";